import { useDateNow, useReduxState } from 'hooks';
import { FormattedDateWithTime } from 'components/common';

interface Props {
  endDate: string | null;
  startDate: string | null;
  includePathTileDot?: boolean;
  useUserTexts?: boolean;
}

const PublishedProductText = ({
  startDate,
  endDate,
  includePathTileDot = false,
  useUserTexts = false
}: Props) => {
  const { dateNow } = useDateNow();

  const { messages, theme } = useReduxState();

  return (
    <div className="status">
      {!startDate ? (
        <span className="not-published">
          {includePathTileDot && <span className="dot-separator">{'•'}</span>}
          {messages.commonNotPublished}
        </span>
      ) : Date.parse(startDate) > dateNow ? (
        <span className="will-publish">
          {includePathTileDot && <span className="dot-separator">{'•'}</span>}
          <FormattedDateWithTime
            inputDate={startDate}
            text={
              useUserTexts ? messages.courseOpens : messages.courseWillPublish
            }
          />
        </span>
      ) : Date.parse(endDate) >= dateNow && useUserTexts ? (
        <span className="ends">
          {includePathTileDot && <span className="dot-separator">{'•'}</span>}
          <FormattedDateWithTime
            inputDate={endDate}
            text={messages.courseEnds}
          />
        </span>
      ) : Date.parse(endDate) >= dateNow ? (
        <span className="published-ends">
          {includePathTileDot && <span className="dot-separator">{'•'}</span>}
          <FormattedDateWithTime
            inputDate={endDate}
            text={messages.coursePublishedAndEnds}
          />
        </span>
      ) : Date.parse(endDate) < dateNow ? (
        <span className="ended">
          {includePathTileDot && <span className="dot-separator">{'•'}</span>}
          <FormattedDateWithTime
            inputDate={endDate}
            omitTime={true}
            text={useUserTexts ? messages.courseHasEnded : messages.courseEnded}
          />
        </span>
      ) : !useUserTexts ? (
        <span className="published">
          {includePathTileDot && <span className="dot-separator">{'•'}</span>}
          {messages.commonPublished}
        </span>
      ) : null}

      <style jsx>{`
        .status {
          display: inline-block;
        }
        .dot-separator {
          color: #555;
          margin: 0 7px;
        }
        .not-published,
        .ended {
          color: ${theme.dangerColor};
        }
        .ends {
          color: ${theme.warningStandaloneColor};
        }
        .published,
        .published-ends {
          color: ${theme.successStandaloneColor};
        }
      `}</style>
    </div>
  );
};

export default PublishedProductText;
